import * as React from 'react'
import * as PropTypes from 'prop-types'

// components
import Icon from '../../../../components/ui/Icon/Icon'
import DisplayPhotoForm from '../../../../components/home/DisplayPhotoForm/DisplayPhotoForm'
import AccessibleForm from '../../../../components/accessibility/AccessibleForm/AccessibleForm'
import {
  MainPage,
  Header,
  ReturnIcon,
  Title,
  Content,
} from './UploadAvatarPage.style'

// services
import validateDisplayPhoto from '../../../../services/validation/DisplayPhoto'

// data
import {
  STEP_DEFAULT,
  STEP_UPLOAD,
  STEP_CROPPED,
} from '../../../../services/data/uploadAvatarSteps.json'
import { MAIN } from '../../../../services/data/profilePages.json'

class UploadAvatarPage extends React.Component {
  state = {
    avatarState: STEP_DEFAULT,
  }

  handleAvatarUpload = () => {
    this.setState({
      avatarState: STEP_UPLOAD,
    })
  }

  handleAvatarCrop = () => {
    this.setState({
      avatarState: STEP_CROPPED,
    })
  }

  render() {
    const {
      setProfileModalPage,
      primaryInfo,
      setPrimaryInfo,
      accessToken,
      doPostAvatar,
    } = this.props
    const { avatarState } = this.state
    const { avatarUrl } = primaryInfo || {}

    return (
      <MainPage>
        <Header>
          <ReturnIcon onClick={() => setProfileModalPage(MAIN)}>
            <Icon name="slide-left" />
          </ReturnIcon>

          <Title>Upload Avatar</Title>
        </Header>
        <Content>
          <AccessibleForm
            initialValues={{
              avatarUrl,
            }}
            isInitialValid={!avatarUrl}
            validate={validateDisplayPhoto}
            onSubmit={doPostAvatar({
              accessToken,
              setPrimaryInfo,
              setProfileModalPage,
            })}
            component={DisplayPhotoForm}
            componentProps={{
              submitLabel: 'Update',
              onAvatarUpload: this.handleAvatarUpload,
              onAvatarCrop: this.handleAvatarCrop,
              showSubmitButton: avatarState === STEP_CROPPED,
            }}
            action="/a/avatar"
            method="post"
          />
        </Content>
      </MainPage>
    )
  }
}

UploadAvatarPage.defaultProps = {
  setProfileModalPage: () => {},
  primaryInfo: {},
  doPostAvatar: () => {},
}

UploadAvatarPage.propTypes = {
  setProfileModalPage: PropTypes.func,
  primaryInfo: PropTypes.object,
}

export default UploadAvatarPage
